var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { "min-height": "230px" } }, [
    _vm.dataReady
      ? _c("div", { attrs: { id: "y-product-attributes-wrapper" } }, [
          _c(
            "div",
            { attrs: { id: "y-product-attributes" } },
            [
              Object.keys(_vm.selectableAttributes).length > 0 &&
              _vm.product.configurations.length > 1
                ? _c("div", { staticClass: "y-clear-filters" }, [
                    _c(
                      "div",
                      {
                        staticClass: "attribute-button",
                        on: {
                          click: function ($event) {
                            return _vm.resetSelectedAttributes()
                          },
                        },
                      },
                      [
                        _vm._v("Clear filters "),
                        _c("span", {
                          staticClass: "dashicons dashicons-image-rotate",
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.selectableAttributes, function (values, key) {
                return _c("div", { staticClass: "y-attribute" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: values.length > 1 || _vm.showSingle,
                          expression: "values.length > 1 || showSingle",
                        },
                      ],
                    },
                    [
                      _c("h4", { staticClass: "y-product-code" }, [
                        _c("b", [_vm._v(_vm._s(key) + ":")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "y-select-attribute" },
                        _vm._l(values, function (val) {
                          return _c(
                            "div",
                            {
                              class: {
                                "attribute-button": true,
                                selected: _vm.selectedAttributes[key] === val,
                                highlight: _vm.highlight[key]
                                  ? _vm.highlight[key].includes(val)
                                  : null,
                              },
                              on: {
                                mouseover: function ($event) {
                                  _vm.highlightMatching(true, key, val)
                                },
                                mouseout: function ($event) {
                                  _vm.unhighlight()
                                },
                                click: function ($event) {
                                  return _vm.selectAttribute(key, val)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(val) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          this.options.length > 0
            ? _c(
                "div",
                { staticClass: "y-options-wrapper" },
                [
                  _c("hr"),
                  _vm._v(" "),
                  _c("h3", { staticClass: "y-title" }, [_vm._v("Options")]),
                  _vm._v(" "),
                  _vm._l(_vm.options, function (option) {
                    return _c("div", [
                      _vm.selectedOptions[option.name]
                        ? _c("div", { staticClass: "y-option" }, [
                            _c("h4", { staticClass: "y-product-code" }, [
                              _c("b", [_vm._v(_vm._s(option.name) + ":")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.selectedOptions[option.name].value
                                  ) +
                                  " "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-default btn-sm",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeOption(option.name)
                                    },
                                  },
                                },
                                [_vm._v("Change")]
                              ),
                            ]),
                          ])
                        : _c("div", { staticClass: "option" }, [
                            _c("h4", { staticClass: "y-product-code" }, [
                              _c("b", [_vm._v(_vm._s(option.name) + ":")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "select-attribute" },
                              _vm._l(option.values, function (val) {
                                return _c("span", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedOptions[option.name],
                                        expression:
                                          "selectedOptions[option.name]",
                                      },
                                    ],
                                    staticClass: "subCategoryThumb",
                                    attrs: { id: val.value, type: "radio" },
                                    domProps: {
                                      value: val,
                                      checked: _vm._q(
                                        _vm.selectedOptions[option.name],
                                        val
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.selectedOptions,
                                          option.name,
                                          val
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "thumbnail",
                                      attrs: { for: val.value },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(val.value) +
                                          " +£" +
                                          _vm._s(_vm._f("money")(val.price)) +
                                          "\n                                        "
                                      ),
                                    ]
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]),
                    ])
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          this.accessories.length > 0
            ? _c(
                "div",
                { staticClass: "accessories-wrapper" },
                [
                  _c("hr"),
                  _vm._v(" "),
                  _c("h3", { staticClass: "y-title" }, [_vm._v("Accessories")]),
                  _vm._v(" "),
                  _vm._l(_vm.accessories, function (accessoryGroup) {
                    return _c("div", { staticClass: "accessory" }, [
                      _vm.selectedAccessories[accessoryGroup.name]
                        ? _c("div", [
                            _c("h4", { staticClass: "product-code" }, [
                              _c("b", [
                                _vm._v(_vm._s(accessoryGroup.name)),
                                accessoryGroup.is_required
                                  ? _c("span", { staticClass: "required" }, [
                                      _vm._v("*"),
                                    ])
                                  : _vm._e(),
                                _vm._v(":"),
                              ]),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.selectedAccessories[accessoryGroup.name]
                                      .accessory.name
                                  ) +
                                  " x\n            " +
                                  _vm._s(
                                    _vm.selectedAccessories[accessoryGroup.name]
                                      .count
                                  ) +
                                  " "
                              ),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeAccessory(
                                        accessoryGroup.name
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Change")]
                              ),
                            ]),
                          ])
                        : _c("div", [
                            _c(
                              "h4",
                              { staticClass: "text-capitalize product-code" },
                              [
                                _c("b", [
                                  _vm._v(_vm._s(accessoryGroup.name)),
                                  accessoryGroup.is_required
                                    ? _c("span", { staticClass: "required" }, [
                                        _vm._v("*"),
                                      ])
                                    : _vm._e(),
                                  _vm._v(":"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "select-attribute" },
                              _vm._l(
                                accessoryGroup.items,
                                function (item, index) {
                                  return _c("div", { key: index }, [
                                    item.accessory
                                      ? _c("div", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.selectedAccessories[
                                                    accessoryGroup.name
                                                  ],
                                                expression:
                                                  "selectedAccessories[accessoryGroup.name]",
                                              },
                                            ],
                                            staticClass: "subCategoryThumb",
                                            attrs: {
                                              id: item.accessory.name + index,
                                              type: "radio",
                                              "data-count": item.count,
                                            },
                                            domProps: {
                                              value:
                                                accessoryGroup.items[index],
                                              checked: _vm._q(
                                                _vm.selectedAccessories[
                                                  accessoryGroup.name
                                                ],
                                                accessoryGroup.items[index]
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.selectedAccessories,
                                                  accessoryGroup.name,
                                                  accessoryGroup.items[index]
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "thumbnail",
                                              attrs: {
                                                for:
                                                  item.accessory.name + index,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.accessory.name) +
                                                  " (x" +
                                                  _vm._s(item.count) +
                                                  ") +£" +
                                                  _vm._s(
                                                    _vm._f("money")(
                                                      item.price * item.count
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]),
                    ])
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "y-product-price" },
            [
              _c("div", { staticClass: "m-t-10" }, [
                _c("label", [_vm._v("Ex. VAT")]),
                _vm._v(" "),
                _c("label", { staticClass: "switch", attrs: { name: "" } }, [
                  _c("input", {
                    attrs: { label: "VAT Checkbox", type: "checkbox" },
                    domProps: { checked: _vm.vatToggle },
                    on: { click: _vm.updateVatToggle },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "slider round" }),
                ]),
                _vm._v(" "),
                _c("label", [_vm._v("Inc. VAT")]),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", { staticClass: "y-price-sales" }, [
                  _vm._v(_vm._s(!_vm.product.sku ? "From" : "") + " £"),
                  _vm.product.poa == 1
                    ? _c("span", [_vm._v("POA")])
                    : _c("span", [
                        _vm._v(_vm._s(_vm._f("money")(_vm.viewPrice))),
                      ]),
                ]),
                _vm._v(" "),
                _vm.product.poa != 1
                  ? _c("span", { staticClass: "price-tag" }, [
                      _vm._v(
                        " per " +
                          _vm._s(_vm.product.unit_per_sale) +
                          " " +
                          _vm._s(!_vm.vatToggle ? "excluding" : "including") +
                          " VAT."
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.product.poa != 1
                ? _c("div", [
                    _c("span", { staticClass: "y-price-sales" }, [
                      _vm._v("£" + _vm._s(_vm._f("money")(_vm.animatedPrice))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "price-tag" }, [
                      _vm._v(
                        "total " +
                          _vm._s(!_vm.vatToggle ? "excluding" : "including") +
                          " VAT, "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "show-delivery-costs",
                          attrs: { href: "#delivery" },
                        },
                        [_vm._v("delivery costs")]
                      ),
                      _vm._v(" may apply."),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.product.sales_discounts.length > 0
                ? _c("div", { staticStyle: { "margin-top": "5px" } }, [
                    _c("table", { staticClass: "table table-hover" }, [
                      _c(
                        "tbody",
                        [
                          _c("th", [_vm._v("From")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("To")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Price")]),
                          _vm._v(" "),
                          _vm._l(_vm.product.sales_discounts, function (entry) {
                            return _c("tr", [
                              entry.to_count > 0
                                ? _c("td", [_vm._v(_vm._s(entry.from_count))])
                                : _c("td", [
                                    _vm._v(_vm._s(entry.from_count) + "+"),
                                  ]),
                              _vm._v(" "),
                              entry.to_count > 0
                                ? _c("td", [_vm._v(_vm._s(entry.to_count))])
                                : _c("td"),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "£" +
                                    _vm._s(
                                      _vm._f("money")(
                                        _vm.discountedItemPrice(entry.price)
                                      )
                                    )
                                ),
                              ]),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.product.is_sell_online && _vm.product.poa != 1
                ? _c(
                    "form",
                    [
                      !_vm.product.sku || _vm.disabled
                        ? _c(
                            "VTooltip",
                            {
                              staticClass: "yodah-flex-container m-t-10",
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "popper",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n            Please select options before you can add to the basket\n          "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3018663388
                              ),
                            },
                            [
                              _c("div", { staticClass: "flex-70" }, [
                                _c("input", {
                                  staticClass: "form-control input",
                                  attrs: {
                                    disabled: !_vm.product.sku || _vm.disabled,
                                    type: "number",
                                    placeholder:
                                      "Quantity (please select options above first)",
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex-30" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "y-btn y-basket-btn flex-100",
                                    attrs: { disabled: "" },
                                  },
                                  [_vm._v("Add to basket")]
                                ),
                              ]),
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "yodah-flex-container m-t-10" },
                            [
                              _c("div", { staticClass: "flex-70" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.quantity,
                                      expression: "quantity",
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        min_value: _vm.product.min_sale_count
                                          ? _vm.product.min_sale_count
                                          : 0,
                                        max_value: 500,
                                      },
                                      expression:
                                        "{min_value:(product.min_sale_count?product.min_sale_count:0), max_value:500}",
                                    },
                                  ],
                                  staticClass: "form-control input",
                                  staticStyle: { "margin-bottom": "0" },
                                  attrs: {
                                    required: "",
                                    type: "number",
                                    min: _vm.product.min_sale_count,
                                    max: 500,
                                    placeholder: "Quantity",
                                    pattern: "[0-9]*",
                                    inputmode: "numeric",
                                    name: "quantity",
                                  },
                                  domProps: { value: _vm.quantity },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.quantity = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("input", { attrs: { type: "hidden" } }),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex-30" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "y-btn y-basket-btn flex-100",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.addToBasket.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Add to basket")]
                                ),
                              ]),
                            ]
                          ),
                      _vm._v(" "),
                      _vm.ppClientId
                        ? _c("div", {
                            staticClass: "y-pp-finance",
                            attrs: {
                              "data-pp-message": "",
                              "data-pp-style-layout": "text",
                              "data-pp-style-logo-type": "inline",
                              "data-pp-style-text-color": "black",
                              "data-pp-amount": _vm.totalPrice + _vm.totalTax,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.msg,
                              expression: "msg",
                            },
                          ],
                          staticClass: "y-modal fade in",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "y-modal-dialog y-modal-bg-1 fade in",
                              on: { click: function ($event) {} },
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.msg,
                                      expression: "msg",
                                    },
                                  ],
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-times",
                                    staticStyle: {
                                      "font-size": "20px",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.msg = ""
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("table", [
                                _c("tr", [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.currentProduct.name
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("h4", [
                                      _vm._v(
                                        "£" +
                                          _vm._s(
                                            _vm._f("money")(
                                              _vm.$store.state.basketValues
                                                .gross
                                            )
                                          )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "flex-end",
                                    "align-items": "flex-end",
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        "margin-right": "5px",
                                        color: "gray",
                                        "text-decoration": "underline",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.msg = ""
                                        },
                                      },
                                    },
                                    [_vm._v("Continue Shopping")]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(3),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "y-modal-backdrop",
                            on: {
                              click: function ($event) {
                                _vm.msg = ""
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("quantity"),
                              expression: "errors.has('quantity')",
                            },
                          ],
                          staticClass:
                            "control has-icon has-icon-right qty-error",
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-warning",
                            staticStyle: { color: "#E74C3C" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "help has-error" }, [
                            _vm._v(" " + _vm._s(_vm.errors.first("quantity"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "cannot-buy-online" }, [
                    _vm._v(
                      _vm._s(
                        _vm.notAvailableText
                          ? _vm.notAvailableText
                          : "This product is not available to buy online."
                      ) +
                        _vm._s(
                          _vm.contact
                            ? " Click quick quote below to continue."
                            : ""
                        )
                    ),
                  ]),
              _vm._v(" "),
              _vm.product.availability
                ? _c("div", [
                    _c("p", { staticClass: "availability" }, [
                      _vm._v(
                        "Availability: " + _vm._s(_vm.product.availability)
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.product
                ? _c("div", [
                    _c(
                      "div",
                      [
                        _vm._l(_vm.product.common_files, function (file) {
                          return _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-info btn-lg m-t-10 btn-block",
                              attrs: {
                                title: "Download" + file.original_name,
                                href: "/uploads/products/" + file.name,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "glyphicon glyphicon-download-alt",
                              }),
                              _vm._v(" Download " + _vm._s(file.original_name)),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.product.files, function (file) {
                          return _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-info btn-lg m-t-10 btn-block",
                              attrs: {
                                title: "Download" + file.original_name,
                                href: "/uploads/products/" + file.name,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "glyphicon glyphicon-download-alt",
                              }),
                              _vm._v(" Download " + _vm._s(file.original_name)),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.contact
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-lg btn-block m-t-15",
                      attrs: {
                        "data-target": "#how-to-order-modal",
                        "data-toggle": "modal",
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-question-circle" }),
                      _vm._v(" Quick quote\n      "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.contact
                ? _c("product-contact-modal", {
                    attrs: {
                      sku: _vm.product.sku,
                      options: _vm.selectedOptions,
                      accessories: _vm.selectedAccessories,
                      product: _vm.product,
                      email: _vm.email,
                      tel: _vm.tel,
                      telString: _vm.telString,
                      openingHours: _vm.openingHours,
                      yodahURL: _vm.yodahURL,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", { staticStyle: { "font-size": "20px" } }, [
      _c("b", [
        _c("i", {
          staticClass: "fa fa-check-circle",
          staticStyle: { color: "green" },
        }),
        _vm._v(" Added to basket"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "text-right p-r-5" }, [
      _c("h4", [_c("b", [_vm._v("Item: ")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "text-right p-r-5" }, [
      _c("h4", [_c("b", [_vm._v("Basket total: ")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { staticClass: "btn btn-inverse", attrs: { href: "../../basket/" } },
      [
        _vm._v("Proceed to Checkout "),
        _c("i", { staticClass: "fa fa-arrow-circle-right" }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }